<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" width="40%">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="baseForm" :model="formData" :label-width="100">

            <FormItem label="领取地点名称" prop="place" :rules="[rules.required]">
                <Input v-model="formData.place" placeholder="领取地点名称"></Input>
            </FormItem>
            <FormItem label="工作时间" prop="workTime" :rules="[rules.required]">
                <Input v-model="formData.workTime" placeholder="工作时间"></Input>
            </FormItem>
            <FormItem label="联系电话" prop="mobile" :rules="[rules.required]">
                <Input v-model="formData.mobile" placeholder="联系电话"></Input>
            </FormItem>
        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="warning" @click="handleSubmit()">通知</Button>
        </div>
    </Modal>
</template>

<script>
    import iEquip from "@/module/main/api/iEquip";
    import modalHelper from "@/mixins/modalHelper";
    import rules from '@/libs/rules';
    import _don from "@/libs/doson";

    const formModal = {
        id:null,
        equipment:{id:null},
        place:null,
        workTime:'上午9点到12点,下午2点到5点',
        status:0,
        mobile:null
    };

    export default {
        name: "receive-edit",
        mixins: [modalHelper],
        components: {

        },
        props:{
          equipId:{
              type:Number,
              default:0
          }
        },
        data() {
            return {
                formData: _don.cloneWithModal(formModal),
                title: '号牌通知'
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {
                //_don.cloneWithModal(formModal, this.formData, this.dataSource);
                this.formData.equipment.id = this.equipId
            },
            async handleSubmit(type) {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    // 提交
                    iEquip.receiveAdd(this.formData).then(() => {
                        this.$Message.success('操作成功');
                        this.$emit('on-success', this.formData);
                        this.currValue = false;
                    }).loadingSwitch(this, 'loading');
                });

            },
        },
        computed: {
        },
        watch:{

        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:28px;
    }
</style>
